import { useErrorBoundary } from 'react-error-boundary';
import { useRegistrationStore } from '../store/store.ts';
import { HEADER_NAMES } from '../utils/constants.ts';
import { CASUMO_BRAND_ID } from '../utils/envConstants.ts';

export const useFetcher = () => {
  const { showBoundary } = useErrorBoundary();
  const { setLoading } = useRegistrationStore();

  const handleError = (error: Error) => {
    showBoundary(error);
    throw error;
  };

  const fetcher = async (...args: [RequestInfo, RequestInit?]) => {
    try {
      setLoading(true);
      const response = await fetch(...args);

      if (response.status === 404) {
        handleError(new Error(`HTTP error! status: ${response.status}`));
      }

      const res = await response.json();
      setLoading(false);

      return res;
    } catch (error: unknown) {
      setLoading(false);
      handleError(error as unknown as Error);
    }
  };

  return fetcher;
};

export const apiClient = async (
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',
  body?: unknown,
  options: RequestInit = {},
) => {
  try {
    const { setLoading } = useRegistrationStore.getState();
    setLoading?.(true);

    const fetchOptions: RequestInit = {
      method,
      headers: {
        'Content-Type':                 'application/json',
        [HEADER_NAMES.CASUMO_BRAND_ID]: `${CASUMO_BRAND_ID}`,
        ...options.headers,
      },
      body: body ? JSON.stringify(body) : undefined,
      ...options,
    };

    setLoading?.(false);

    return await fetch(url, fetchOptions);
  } catch (error) {
    useRegistrationStore.getState().setLoading?.(false);
    throw error;
  }
};
